var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_13136_96448)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_13136_96448",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 2,
    y: 2,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.32812 2.33203H22.3281V22.332H2.32812V2.33203Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_13136_96448)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8516 14.3059L11.0559 14.6432C11.3605 15.146 11.5243 15.7492 11.5243 16.368C11.5243 16.7459 11.4631 17.1204 11.3441 17.4712L11.0719 18.2734H13.5771L13.3049 17.4712C13.1859 17.1204 13.1247 16.7459 13.1247 16.368C13.1247 15.7492 13.2885 15.146 13.5931 14.6432L13.7973 14.3061",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18007 6.58098H5.33343C5.17362 6.58098 5.04886 6.71832 5.0637 6.87742C5.1096 7.36945 5.21944 8.0098 5.47061 8.67344C5.89233 9.78773 6.58237 10.6529 7.53171 11.2617",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.08872 13.375C6.0629 12.6138 4.7484 10.6411 4.17805 9.09844C3.55411 7.4109 3.68036 5.89555 3.68602 5.83188C3.71747 5.4793 4.01293 5.20902 4.36692 5.20902H7.18645",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.4609 6.57656H19.3076C19.4674 6.57656 19.5921 6.71391 19.5773 6.87301C19.5514 7.15039 19.5052 7.47492 19.4248 7.82422",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5547 13.375C18.5805 12.6138 19.8951 10.6411 20.4654 9.09844C21.0894 7.4109 20.9631 5.89555 20.9575 5.83188C20.926 5.4793 20.6305 5.20902 20.2766 5.20902H17.457",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.9865 9.11547C18.568 9.99926 17.9587 10.7045 17.1641 11.2266",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3627 2.62227H17.7991C17.9986 2.62227 18.1604 2.78406 18.1604 2.98355V3.89066C18.1604 4.09016 17.9986 4.25195 17.7991 4.25195H6.84566C6.64613 4.25195 6.48438 4.09016 6.48438 3.89066V2.98355C6.48438 2.78406 6.64613 2.62227 6.84566 2.62227H8.98906",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.322 14.5234C9.48633 14.5234 7.1875 12.2246 7.1875 9.38891V4.25437H17.4566V9.38891C17.4566 12.2246 15.1577 14.5234 12.322 14.5234Z",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.4409 20.1602H9.20312V19.2535C9.20312 18.715 9.63965 18.2785 10.1781 18.2785H14.4659C15.0043 18.2785 15.4409 18.715 15.4409 19.2535V20.1602Z",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8027 22.0391H7.84652C7.70691 22.0391 7.59375 21.9259 7.59375 21.7863V20.4101C7.59375 20.2705 7.70691 20.1573 7.84652 20.1573H16.8027C16.9423 20.1573 17.0554 20.2705 17.0554 20.4101V21.7863C17.0554 21.9259 16.9423 22.0391 16.8027 22.0391Z",
    stroke: "#6F767E",
    strokeWidth: 0.727273,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_13136_96448"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(2.33594 2.33398)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRanking);
export default __webpack_public_path__ + "static/media/ranking.7835ddda8be409db6f2b00e6eaf9e389.svg";
export { ForwardRef as ReactComponent };